export default __webpack_public_path__ + "static/media/androidPhone.177e4311.webp";